class Modal {

	constructor() {
		this.toggleModal();
	}

	toggleModal() {
    ( function( $ ) {
      if($('.cover-bg-modal.prevent-closing').length){
  			$('body').addClass('overflow-hidden');
  		}

      $(document).on('click', '.toggle-modal', function(){
        $('#' + $(this).data('target')).addClass('show');
  			$('body').addClass('overflow-hidden');
      });

      $(document).on('click', '.close-cover-modal', function(){
        $(this).closest('.cover-bg-modal:not(.prevent-closing)').removeClass('show');

  			if(!$(this).closest('.cover-bg-modal').hasClass('prevent-closing')){
  				$('body:not(.mobile-menu-open)').removeClass('overflow-hidden');
  			}
      });

      $(document).on('click', '.cover-bg-modal', function(e){
        if($(e.target).hasClass('cover-bg-modal') && !$(e.target).hasClass('prevent-closing')){
  				$('body:not(.mobile-menu-open)').removeClass('overflow-hidden');
  				$(this).closest('.cover-bg-modal').removeClass('show');
        }
      });
		}( jQuery ) );
	}
}

export default Modal;
